import SchoolQuality from './SchoolQuality.component';

export default SchoolQuality;
